import { isVideoStation } from '@app/core/stations/helpers';
import { Segment, Station, TimeRange } from '@mi-front/core';
import { AudioStatusPreview } from './AudioStatusPreview';
import { VideoStatusPreview } from './VideoStatusPreview';

interface Props {
  readonly station: Station;
  readonly segments: readonly Segment[];
  readonly range: TimeRange;
}

/**
 * Factory component that returns the appropriate preview component
 * based on whether the station is a video station or not.
 */
export function StatusPreview(p: Props) {
  const { station, segments, range } = p;

  return isVideoStation(station) ? (
    <VideoStatusPreview station={station} segments={segments} range={range} />
  ) : (
    <AudioStatusPreview station={station} segments={segments} range={range} />
  );
}
